const {apiV2CryptoWalletsList} = require("../../../../../api/merchant/cryptoWallet");
const {apiGetMerchantAppBalance} = require("../../../../../api/merchant/balance");

module.exports = ({assetCode, walletSelectId, formCtx}) => (name, selectedApp) => {
  const onChange = formCtx.onManualChange;

  onChange({[name]: selectedApp});

  formCtx.enableLoadingState();

  const walletsList = apiV2CryptoWalletsList({app_id: selectedApp}).then((res) => {
    return res.list
        .filter((el) => el.cc_code === assetCode && el.enabled)
        .map(({id, address, enabled}) => ({id, address, disabled: !enabled}));
  });

  const appBalance = apiGetMerchantAppBalance({app_id: selectedApp}).then((res) => {
    const balances = res.balance_merchant.balances.find((el) => el.asset_code === assetCode) || {};
    return balances.available || '0';
  });

  return Promise.all([walletsList, appBalance])
      .then(([walletsList, appBalance]) => {
        onChange({
          appBalance,
          walletsList,
          [walletSelectId]: walletsList.length === 1 ? walletsList[0].id : ''
        })
      }).finally(() => {
        formCtx.disableLoadingState();
      })
}
